import gdpr_flow from './items/gdpr_flow.js';
import unicorn_flow from './items/unicorns_items.js';
import dmp_flow from './items/dmp_items.js';
import agreement_classifier_flow from './items/agreement_classifier_items.js';
import { createDefaultRegistry } from './engine/flowRegistry';

export const defaultRegistry = createDefaultRegistry();

// Register all known flows up-front.
[gdpr_flow, unicorn_flow, dmp_flow, agreement_classifier_flow].forEach((f) => defaultRegistry.register(f));
